import {Resizable} from 're-resizable'
import * as React from 'react'
import Draggable from 'react-draggable'
import {IExportMapDispatcher, IPopupDispatcher} from '../../interfaces/dispatchers'
import {IExportMap, IStore} from '../../interfaces/reducers'
import {getMapService} from '../../reducers/map'
import OverlayLoader from '../Loading/OverlayLoading'
import {DefaultTemplate} from './DefaultTemplate'

export interface OwnProps {
  exportMapProps: IExportMap
  hardLoading: boolean
}

export interface ParentProps {
  children?: React.ReactNode
}

export interface DispatchProps extends IExportMapDispatcher, IPopupDispatcher {}

export type Props = OwnProps & ParentProps & DispatchProps

export interface State {}

export class PrintPreview extends React.Component<Props, State> {
  private draggableRef = React.createRef<HTMLDivElement>()

  constructor(props: Props) {
    super(props)
    this.state = {
      sidebarHeight: '100%',
      sidebarWidth: '100%'
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.exportMapProps.previewMode && !this.props.exportMapProps.previewMode) {
      this.setState({...this.state, sidebarHeight: '100%', sidebarWidth: '100%'})
    }
  }

  wrapElements(element: JSX.Element): JSX.Element {
    return element
  }

  getMap() {
    const width = this.props.exportMapProps.previewMode
      ? `${this.props.exportMapProps.mapProps.resizibleWidth}px`
      : '100%'
    const height = this.props.exportMapProps.previewMode
      ? `${this.props.exportMapProps.mapProps.resizibleHeight}px`
      : '100%'
    const defPositin = {
      x: this.props.exportMapProps.previewMode ? this.props.exportMapProps.mapProps.resizibleLeft : 0,
      y: this.props.exportMapProps.previewMode ? this.props.exportMapProps.mapProps.resizibleTop : 0
    }
    const bounds = {
      left: 0,
      right: this.props.exportMapProps.previewMode
        ? this.props.exportMapProps.defaultLayoutWidth / this.props.exportMapProps.dpiFactor
        : 0,
      top: 0,
      bottom: this.props.exportMapProps.previewMode
        ? this.props.exportMapProps.defaultLayoutHeight / this.props.exportMapProps.dpiFactor
        : 0
    }
    return (
      <Draggable
        // axis={(props.isMobile || !props.popupSettings[id].draggableAxis) ? "none" : props.popupSettings[id].draggableAxis}
        handle=".print-tool-draggable"
        position={defPositin}
        bounds={bounds}
        nodeRef={this.draggableRef}
        // onStart={handleStart}
        // onDrag={}
        onStop={(e, d) => {
          this.props.setMapDivProps(
            this.props.exportMapProps.mapProps.resizibleWidth,
            this.props.exportMapProps.mapProps.resizibleHeight,
            d.lastX,
            d.lastY
          )
        }}
      >
        <div
          ref={this.draggableRef}
          style={{
            width: this.props.exportMapProps.previewMode ? '' : '100%',
            height: this.props.exportMapProps.previewMode ? '' : '100%'
          }}
        >
          <div className="print-tool print-tool-draggable" style={{cursor: 'move'}}>
            <i className="fas fa-arrows-alt" />
          </div>
          <Resizable
            key={'map'}
            handleComponent={{
              bottomRight: <span className="resizible-teo-drag"></span>
            }}
            onResize={(event, direction, elementRef, delta) => {
              if (elementRef.style.width && elementRef.style.height) {
                this.props.setMapDivProps(
                  parseInt(elementRef.style.width.replace('px', '')),
                  parseInt(elementRef.style.height.replace('px', '')),
                  this.props.exportMapProps.mapProps.resizibleLeft,
                  this.props.exportMapProps.mapProps.resizibleTop
                )
              }
              if (getMapService()) {
                getMapService().updateSize()
              }
            }}
            size={{width: width, height: height}}
            maxWidth={bounds.right || '100%'}
            maxHeight={bounds.bottom || '100%'}
            enable={{
              right: this.props.exportMapProps.previewMode,
              bottom: this.props.exportMapProps.previewMode,
              bottomRight: this.props.exportMapProps.previewMode
            }}
          >
            {this.props.children}
          </Resizable>
        </div>
      </Draggable>
    )
  }

  getDrawingTemplate(): JSX.Element {
    return (
      <DefaultTemplate
        addPopups={this.props.addPopups}
        removePopups={this.props.removePopups}
        updateElementProps={this.props.updateElementProps}
        theRealThing={false}
        exportMapProps={this.props.exportMapProps}
        onTemplateRendered={e => {}}
      />
    )
  }

  getRealTemplate(): JSX.Element {
    return (
      <div
        style={{
          position: 'absolute',
          zIndex: -9,
          height: '0',
          width: '0',
          overflow: 'hidden',
          opacity: 0 // comment to debug
        }}
      >
        <DefaultTemplate
          addPopups={this.props.addPopups}
          removePopups={this.props.removePopups}
          updateElementProps={this.props.updateElementProps}
          theRealThing={true}
          exportMapProps={this.props.exportMapProps}
          onTemplateRendered={e => {
            this.props.setPaper(e)
          }}
        />
      </div>
    )
  }
  getPosition(el: HTMLElement) {
    let xPosition = 0
    let yPosition = 0

    while (el) {
      if (el.tagName == 'BODY') {
        // deal with browser quirks with body/window/document and page scroll
        const xScrollPos = el.scrollLeft || document.documentElement.scrollLeft
        const yScrollPos = el.scrollTop || document.documentElement.scrollTop

        xPosition += el.offsetLeft - xScrollPos + el.clientLeft
        yPosition += el.offsetTop - yScrollPos + el.clientTop
      } else {
        xPosition += el.offsetLeft - el.scrollLeft + el.clientLeft
        yPosition += el.offsetTop - el.scrollTop + el.clientTop
      }

      el = el.offsetParent as HTMLElement
    }
    return {
      x: xPosition,
      y: yPosition
    }
  }
  render() {
    const w = this.props.exportMapProps.previewMode
      ? `${this.props.exportMapProps.defaultLayoutWidth / this.props.exportMapProps.dpiFactor}px`
      : '100%'
    const h = this.props.exportMapProps.previewMode
      ? `${this.props.exportMapProps.defaultLayoutHeight / this.props.exportMapProps.dpiFactor}px`
      : '100%'
    const paperStyle: React.CSSProperties = {
      position: 'relative',
      minWidth: w,
      minHeight: h,
      maxWidth: w,
      maxHeight: h,
      width: w,
      height: h,
      backgroundColor: 'white',
      transform: this.props.exportMapProps.previewMode ? `scale(${this.props.exportMapProps.zoomFactor})` : '',
      transformOrigin: 'top left',
      cursor: 'pointer'
    }
    return (
      <div
        style={{
          padding: this.props.exportMapProps.previewMode ? '30px' : '0',
          width: '100%',
          height: '100%',
          backgroundColor: 'gray',
          boxSizing: 'border-box',
          position: 'relative',
          overflow: 'auto'
        }}
      >
        <OverlayLoader show={this.props.hardLoading}></OverlayLoader>
        <div style={paperStyle}>
          {this.props.exportMapProps.previewMode ? this.getDrawingTemplate() : null}
          {this.props.exportMapProps.previewMode ? this.getRealTemplate() : null}
          {this.getMap()}
        </div>
      </div>
    )
  }
}

export const mapStateToProps = (store: IStore) => {
  return {
    exportMapProps: store.exportMap,
    hardLoading: store.map.hardLoading
  }
}
